import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import OmInputFieldWrapper from '../forms/OmInputFieldWrapper';
import PriceTableContent from './PriceTableContent';
import OmButton from '../forms/OmButton';

import {
    setFundsValue,
    setDateValue,
    getFundsForSelectedDate
} from '@om/redux/actions/priceTable/table';
import {
    getFunds,
    getSelectedDate,
    isSearchButtonDisabled
} from '@om/redux/selectors/priceTable/table';
import {
    getInvestmentSeriesFunds
} from '@om/redux/selectors/priceTable/referenceData';
import { createActionHandler } from '../../util';
import { OmPtContainer } from '@om/component-library-react';

const PriceTableContainer = ({
    slot,
    data
}) => {
    const dispatch = useDispatch();

    const {
        funds,
        investmentSeriesApplicableFunds,
        selectedDate,
        searchButtonDisabled
    } = useSelector(createStructuredSelector({
        funds: getFunds,
        investmentSeriesApplicableFunds: getInvestmentSeriesFunds,
        selectedDate: getSelectedDate,
        searchButtonDisabled: isSearchButtonDisabled,
    }));

    const investmentSeriesFunds = (() => {
        const investmentSeries = [];
        if (funds) {
            funds.forEach(fund => {
                investmentSeriesApplicableFunds.forEach(applicableFund => {
                    if (fund.FundId.trim() === applicableFund.fundId.trim()) {
                        investmentSeries.push(fund)
                    }
                })
            })
        }
        return investmentSeries;
    })();

    const hasGraphs = (() => {
        if (process.env.GATSBY_COUNTRY_SELECTOR === 'za' || process.env.GATSBY_COUNTRY_SELECTOR === 'ut') {
            return true;
        }
        return false;
    })();

    const hasInvestmentFunds = (() => {
        if (process.env.GATSBY_COUNTRY_SELECTOR === 'za'|| process.env.GATSBY_COUNTRY_SELECTOR === 'ut' ) {
            return true;
        }
        return false;
    })();

    useEffect(() => {
        if (selectedDate.value === null) {
            dispatch(setFundsValue(data.allPriceTable.nodes));
        }
    }, [selectedDate, dispatch, data])

    return (
        <OmPtContainer slot={slot}>
            {hasInvestmentFunds
                && <div slot="heading">
                    <h1 className="light center">Investment Series <span>Fund Range</span></h1>
                </div>}
            <div slot="date-picker-form">
                <OmInputFieldWrapper
                    placeholder="dd/mm/yyyy"
                    labelAlwaysShow
                    required="true"
                    keyboardMode="numeric"
                    label="Please enter a date"
                    mask="date"
                    reduxValue={selectedDate}
                    persistHandler={createActionHandler(dispatch, setDateValue)}
                />
                <OmButton
                    size="small"
                    text="Change Date"
                    type="primary"
                    disabled={searchButtonDisabled}
                    onClick={() => dispatch(getFundsForSelectedDate())}
                />
            </div>
            {hasInvestmentFunds
                && <PriceTableContent slot="investment-series-table" fundData={investmentSeriesFunds} hasGraph={hasGraphs} hasPagination={false} />}
            <div slot="table-heading">
                <h1 className="light no-top-margin center">Full <span>Range</span></h1>
            </div>
            <PriceTableContent id="full-range-table" slot="full-range-table" fundData={funds} hasGraph={hasGraphs} hasPagination={true} />
        </OmPtContainer>
    );
}

export default PriceTableContainer;
